import { isEmpty } from "./Modules/isEmpty";

import CanaryIslandsControl from "./Utils/CanaryIslandsControl";
import ZoomBlocker from "./Utils/zoomBlocker";
import Tooltip from "./Tooltip/Tooltip";
import Spinner from "./Utils/Spinner";
import Events from "./Events";
import GeoCoder from "./GeoCoder";
import SourceNLayerManager from "./SourceNLayerManager";
import FullScreenControl from "./Utils/FullScreenControl";

const hover = true;
export default class MapboxMap {
  constructor({ main, opts }) {
    this._ = main;
    this.el = this._.el;

    const mapboxConfiguration = opts.mapboxConfiguration;

    const mapboxModules = opts.modules;
    const legendTitle = opts.legendTitle;

    mapboxgl.accessToken = mapboxConfiguration.token;

    const {
      spinnerLoader,
      mapSettings,
      geocoderSettings,
      fullScreen,
      createFlytoCanariasButton,
      hash,
    } = this._.settings.getSettings();
    const { isDesktop } = this._.sizes;

    // set an accesor to the map container
    this.elMap = this.el.querySelector(`.${mapSettings.mapContainer}`);

    this.defaultZoom = isDesktop
      ? mapSettings.zoom.desktop
      : mapSettings.zoom.mobile;

    this.defaultCenter = isDesktop
      ? mapSettings.center.desktop
      : mapSettings.center.mobile;

    this.mapboxmap = new mapboxgl.Map({
      container: this.elMap, // container id
      style: mapboxConfiguration.styleURL,
      center: isDesktop
        ? mapSettings.center.desktop
        : mapSettings.center.mobile, // starting position [lng, lat]
      zoom: this.defaultZoom || 8,
      minZoom: mapSettings.minZoom,
      maxZoom: mapSettings.maxZoom,
      maxBounds: mapSettings.maxBounds,
      hash: hash,
      attributionControl: this.attributionControl,
      preserveDrawingBuffer: mapSettings.preserveDrawingBuffer,
    });

    // disable map rotation using right click + drag
    this.mapboxmap.dragRotate.disable();

    // disable map rotation using touch rotation gesture
    this.mapboxmap.touchZoomRotate.disableRotation();

    if (mapSettings.zoomControls.show.desktop === true && isDesktop === true) {
      this.createZoomControls(mapSettings);
    } else if (
      mapSettings.zoomControls.show.mobile === true &&
      isDesktop === false
    ) {
      this.createZoomControls(mapSettings);
    }

    if (mapSettings.disableScrollZoom == true) {
      this.mapboxmap.scrollZoom.disable();
    }

    if (isDesktop === true && mapSettings.createZoomBlocker) {
      new ZoomBlocker(this.mapboxmap, this._);
    }

    if (createFlytoCanariasButton === true) {
      const controlCanaryIslands = new CanaryIslandsControl({
        main: this._,
        opts: {
          className: "mapbox-gl-canary-islands",
          title: "Ver Islas Canarias",
          center: this.defaultCenter,
          zoom: this.defaultZoom,
        },
      });

      this.controlCanaryIslands = controlCanaryIslands;

      this.mapboxmap.addControl(controlCanaryIslands, "bottom-left");

      this.controlCanaryIslands.checkIfMapsIsOverCanaryIslands(this.mapboxmap);
    }

    if (isEmpty(geocoderSettings) === false) {
      this.geoCoder = new GeoCoder({
        main: this,
        opts: Object.assign(geocoderSettings, {
          map: this.mapboxmap,
        }),
      });
    }

    if (fullScreen == true && isDesktop === false) {
      this.fullScreenControl = new FullScreenControl({
        main: this._,
        opts: {
          map: this.mapboxmap,
          canvas: this.mapboxmap._canvas,
          clickLayer: this._.el.querySelector(".g-map-wrapper"),
        },
      });
    } else {
      this.el.classList.add("g-fullscreen-off");
    }

    if (this.createScaleBar && isDesktop) {
      var scale = new mapboxgl.ScaleControl({
        unit: "metric",
      });
      this.mapboxmap.addControl(scale, "bottom-right");
    }

    this.tooltip = new Tooltip({
      main: this._,
      opts: {
        el: this.el,
        hoverBlockedRight: this._.settings.get("hoverBlockedRight"),
        buildTooltipHTML: this._.settings.get("buildTooltipHTML"),
      },
    });

    if (spinnerLoader) {
      this.spinner = new Spinner({ main: this._, opts: { MapboxMap: this } });
    }

    this.events = new Events({
      main: this._,
      opts: { MapboxMap: this, mapboxConfiguration, mapboxModules },
    });
    this.sourceLayerManager = new SourceNLayerManager({ main: this._, opts });
    return this;
  }

  createZoomControls(mapSettings) {
    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
    });
    this.mapboxmap.addControl(nav, mapSettings.zoomControls.position);
  }
}
